import { BlockQuote } from '@doist/marketist'

import cn from 'classnames'

import css from './Blockquote.module.css'

export type BlockquoteProps = {
    className?: string
    children?: React.ReactNode
}

export function Blockquote({ children, className, ...rest }: BlockquoteProps) {
    return (
        <BlockQuote
            className={cn(css.blockquote, className)}
            tag="blockquote"
            size="blockquote-sm"
            {...rest}
        >
            {children}
        </BlockQuote>
    )
}
